<template>
    <div class="container">
        <div class="col-lg-8">
            <div v-if="dataIsMobile" class="mb-3">
                <select class="form-control" v-model="params.file_category" @change="getResults">
                    <option :value="null">{{ dataTexts.category_all }}</option>
                    <option v-for="fileCategory in dataFileCategories" :key="fileCategory.id" :value="fileCategory.id">{{ fileCategory.name }}</option>
                </select>
            </div>
            <div class="row mb-4" v-else>
                <span class="col-md btn btn-danger rounded-0 mr-2 mb-2 mb-md-0" :class="{'btn-dark': !params.file_category, 'btn-sm': dataIsMobile}" @click="params.file_category = null; getResults()">{{ dataTexts.category_all }}</span>
                <span class="col-md btn btn-danger rounded-0 mr-2 mb-2 mb-md-0" :class="{'btn-dark': params.file_category == fileCategory.id, 'btn-sm': dataIsMobile}" v-for="fileCategory in dataFileCategories" :key="fileCategory.id" @click="params.file_category = fileCategory.id; getResults()">{{ fileCategory.name }}</span>
            </div>
            <div class="row mb-3">
                <div class="col-md-6 mb-2 mb-md-0">
                    <label>{{ dataTexts.label_search }}</label>
                    <input type="text" class="form-control" v-model="params.search" @keydown.enter="getResults">
                </div>
                <div class="col-6 col-md-3 d-flex align-items-end">
                    <button type="submit" class="button button-border button-fill button-red button-small" @click="getResults"><i
                        class="icon-search"></i> <span>{{ dataTexts.button_search }}</span></button>
                </div>
                <div class="col col-md py-1 pl-2 d-flex align-items-end"><span v-if="showReset" @click="reset" class="btn btn-link btn-sm "><i class="icon-line-cross"></i> {{ dataTexts.button_reset }}</span></div>
            </div>
        </div>
        <div class="col-12">
            <div class="row font-weight-bold py-2 bg-white">
                <div class="col-md-6">{{ dataTexts.column_file }}</div>
                <div class="col-md text-center d-none d-md-block">{{ dataTexts.column_type }}</div>
                <div class="col-md text-center d-none d-md-block">{{ dataTexts.column_size }}</div>
            </div>
            <div class="row py-2" v-for="(file, index) in files" :key="file.id" :class="{'bg-white': index % 2 != 0}">
                <div class="col-md-6">
                    <a :href="file.file" target="_blank"><i class="icon-line-download"></i> {{ file.title }}</a>
                </div>
                <div class="col-md text-center d-none d-md-block">{{ file.type }}</div>
                <div class="col-md text-center d-none d-md-block">{{ file.size }}</div>
            </div>
            <div class="alert alert-secondary rounded-0 mt-3" v-if="!files.length">{{ dataTexts.message_no_files_found }}</div>
            <div class="row pt-4">
                <pagination
                    :data="result"
                    :show-disabled="true"
                    :limit="3"
                    @pagination-change-page="getResults"
                ></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import pagination from "laravel-vue-pagination";
export default {
    components: {
        pagination,
    },
    props: ["dataIsMobile", "dataTexts", "dataFileCategories"],
    data() {
        return {
            files: [],
            result: {},
            params: {
                file_category: null,
                search: null
            }
        };
    },
    methods: {
        getResults(page = 1) {
            this.page = page;
            axios
                .get("/ajax/files", {
                    params: {
                        page: Number.isInteger(page) ? page : null,
                        pagination: this.pagination,
                        ...this.params,
                    },
                })
                .then((response) => {
                    this.result = response.data;
                    this.files = this.result.data;
                })
        },
        reset() {
            this.params.search = null
            this.getResults()
        }
    },
    computed: {
        showReset() {
            if (this.params.search
            ) {
                return true;
            }
        }
    },
    mounted() {
        this.getResults()
    }
};
</script>
